import { defineTour } from '@lopettia/simul';

/**
 * RevOps — process templates and data quality. Mirrors
 * docs/manuals/10-revops.md.
 */
export const revopsTour = defineTour({
  name: 'RevOps maintenance',
  description:
    'Process template upkeep and the data-quality dashboard a RevOps lead '
    + 'reviews every sprint.',
  steps: [
    {
      id: 'ro-templates',
      kind: 'navigate',
      target: '[data-tour-id="nav-process-templates"]',
      toUrl: '/process-templates',
      prelude: { goto: '/dashboard' },
      message:
        '**Process templates** are versioned. RevOps owns publishing new '
        + 'revisions and rolling them out per team.',
      advanceOn: 'navigate',
    },
    {
      id: 'ro-dq',
      kind: 'navigate',
      target: '[data-tour-id="nav-data-quality"]',
      toUrl: '/analytics/data-quality',
      message:
        'The **data quality** dashboard surfaces missing fields, duplicate '
        + 'accounts, and stale stages — the work backlog for RevOps.',
      advanceOn: 'navigate',
    },
  ],
});

export default revopsTour;
